<div class="overlay">
    <div class="detail-overlay">
        <div class="detail-view">

            <section class="detail-head">
                <header class="detail-header">
                    <h1 class="detail-heading">
                        {{LABELS.TITLE}}
                    </h1>
                    <button angulartics2On="click" angularticsCategory="Detailansichten"
                            angularticsAction="detail_info_text" angularticsLabel="Abschlags-Check"
                            (click)="infoVisible = !infoVisible">
                        <i class="info-sm dark-grey"></i>
                    </button>
                    <button (click)="close()">
                        <i class="close-sm dark-grey"></i>
                    </button>
                </header>

                <section>
                    <ng-container *ngIf="{
                        financeData: financeData$ | async,
                        financeError: financeDataError$ | async
                        } as data">

                        <div class="finance-details-value center-contents">
                            <ng-container *ngIf="data.financeData && !data.financeError; else emptyState">
                                <div *ngIf="data.financeData.trend < 0">
                                    <div class="status-icon-piggy"></div>
                                    <div>
                                        {{LABELS.LABEL_FRAGMENT_CIRCA}}
                                        <strong>
                                            {{data.financeData.amount}}
                                            {{LABELS.UNIT_FINANCE}}
                                        </strong>
                                        {{LABELS.LABEL_FRAGMENT_CREDIT}}
                                    </div>
                                </div>
                                <div *ngIf="data.financeData.trend === 0">
                                    <div class="status-icon-thumb"></div>
                                    <div>
                                        <strong>
                                            {{LABELS.LABEL_CONSUMPTION_MATCHES}}
                                        </strong>
                                    </div>
                                </div>
                                <div *ngIf="data.financeData.trend > 0">
                                    <div class="status-icon-alert"></div>
                                    <div>
                                        {{LABELS.LABEL_FRAGMENT_CIRCA}}
                                        <strong>
                                            {{data.financeData.amount}}
                                            {{LABELS.UNIT_FINANCE}}
                                        </strong>
                                        {{LABELS.LABEL_FRAGMENT_ADDITIONAL_PAYMENT}}
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #emptyState>
                                <div class="price">
                                    {{LABELS.LABEL_EMPTY_STATE}}
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>

                </section>
            </section>

            <section class="detail-info" *ngIf="infoVisible">
                <div class="info-icon">
                    <i class="info-sm dark-grey"></i>
                </div>
                <div class="info-text">
                    <h2 class="eon-black">{{TEXTS.TILE_INFO.TITLE}}</h2>
                    <p>
                        {{TEXTS.TILE_INFO.PARAGRAPH}}
                    </p>
                </div>
            </section>


            <section class="detail-content">
                <ng-container>
                    <ng-container *ngIf="financeData$ | async as financeData ">
                        <h4>
                            {{LABELS.LABEL_TIMEFRAME}}
                        </h4>
                        <p class="finance-range">
                            {{formatStartDate(financeData.timeframe.begin)}}
                            -
                            {{formatEndDate(financeData.timeframe.end)}}
                        </p>
                        <ng-container [ngSwitch]="financeData.trend">
                            <p *ngSwitchCase="-1">
                                {{TEXTS.TREND.CASE_CREDIT}}
                                {{financeData.amount}}
                                {{TEXTS.TREND.CASE_UNIT}}
                            </p>
                            <p *ngSwitchCase="0">
                                {{TEXTS.TREND.CASE_MATCHES}}
                            </p>
                            <p *ngSwitchCase="1">
                                {{TEXTS.TREND.CASE_ADDITIONAL_PAYMENT}}
                                {{financeData.amount}}
                                {{TEXTS.TREND.CASE_UNIT}}
                            </p>
                        </ng-container>
                    </ng-container>
                    <p> &nbsp;</p>
                    <p>{{TEXTS.ADJUST_ONLINE}}</p>
                    <p>
                        <button class="eon-button-new"
                                (click)="openLink()">
                            {{LABELS.BTN_LABEL_ADJUST}}
                        </button>
                    </p>
                    <p>{{TEXTS.INFO}}</p>
                </ng-container>
            </section>

        </div>
    </div>
</div>


